var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isAuthenticated && _vm.isLoadingAccountState
        ? _c("v-progress-circular", {
            attrs: { indeterminate: "", color: "accent" },
          })
        : _vm.isAccountPaid
        ? _c(
            "v-tooltip",
            {
              attrs: { left: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          _vm._b(
                            {
                              attrs: { color: "accent" },
                              on: { click: _vm.showPayInfo },
                            },
                            "v-icon",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [_vm._v("star")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [_c("span", [_vm._v(_vm._s(_vm.payResource.paidAccess))])]
          )
        : _c(
            "v-chip",
            {
              attrs: { color: "accent", outlined: "" },
              on: { click: _vm.showPayInfo },
            },
            [_vm._v(_vm._s(_vm.payResource.free))]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }